'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { useDesktopOrMobileMediaQuery } from '@/hooks/useMediaQuery';
import { useSequenceSidebarData } from '@/routes/_chat/chat/$sessionId/-query';
import { IndividualSidebar } from '../../-components/IndividualSidebar';
import { loadRequestFormsData } from './-api';
import { RequestSearchBar } from './-components/RequestSearchBar';
import { RequestsListCard } from './-components/RequestsListCard';
export const Route = createFileRoute('/_individual/individual/portal/requests/')({
  loader: () => loadRequestFormsData(),
  component: RequestsPage
});
function RequestsPage() {
  const {
    groups
  } = Route.useLoaderData();
  const sidebarData = useSequenceSidebarData();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const {
    isDesktop
  } = useDesktopOrMobileMediaQuery();
  return <div className="flex h-full min-h-0 w-full overflow-hidden">
      {isDesktop && <IndividualSidebar mode="portal" open={sidebarOpen} onToggle={() => setSidebarOpen(v => !v)} recentSessions={sidebarData.data?.recentSessions ?? []} upcomingInteractions={sidebarData.data?.upcomingInteractions ?? []} />}
      <main className="min-w-0 flex-1 overflow-auto bg-neutral-bottom-fill">
        <div className="min-h-full bg-blue-50/30">
          <div className="mx-auto max-w-[1280px] px-4 py-6 md:px-[100px] md:py-10">
            <div className="mx-auto flex w-full max-w-[800px] flex-col gap-9">
              <RequestSearchBar />
              <RequestsListCard groups={groups} />
            </div>
          </div>
        </div>
      </main>
    </div>;
}